import { render } from "./ExcellencePath.vue?vue&type=template&id=77509db2"
import script from "./ExcellencePath.vue?vue&type=script&lang=js"
export * from "./ExcellencePath.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__